import { IPortalSoftware } from './types';

export const convertSoftware = ({
  ...data
}: IPortalSoftware<string>): IPortalSoftware<Date> => ({
  ...data,
  created_at: new Date(data.created_at),
  updated_at: new Date(data.updated_at),
});
